module.exports = __webpack_public_path__ + "img/0706-汽车种类-下-02.463a594c.png";